'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _sizes = require('../../constants/sizes');

var _alignments = require('../../constants/alignments');

var _input = require('../../atoms/input');

var _input2 = _interopRequireDefault(_input);

var _link = require('../../atoms/link');

var _link2 = _interopRequireDefault(_link);

var _column = require('../../layouts/column');

var _column2 = _interopRequireDefault(_column);

var _row = require('../../layouts/row');

var _row2 = _interopRequireDefault(_row);

var _grid = require('../../layouts/grid');

var _grid2 = _interopRequireDefault(_grid);

var _label = require('../../atoms/text/label');

var _label2 = _interopRequireDefault(_label);

var _container = require('../../layouts/container');

var _container2 = _interopRequireDefault(_container);

var _script = require('../../hocs/script');

var _script2 = _interopRequireDefault(_script);

var _manualAddress = require('../manualAddress');

var _manualAddress2 = _interopRequireDefault(_manualAddress);

var _validatePostalCode = require('../../helpers/validatePostalCode');

var _validatePostalCode2 = _interopRequireDefault(_validatePostalCode);

var _isMobile = require('../../helpers/isMobile');

var _isMobile2 = _interopRequireDefault(_isMobile);

var _getScreenSize = require('../../helpers/getScreenSize');

var _getScreenSize2 = _interopRequireDefault(_getScreenSize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AddressAutocomplete = function AddressAutocomplete(props) {
    var address = props.address,
        allowManual = props.allowManual,
        countryCode = props.countryCode,
        changeEvent = props.changeEvent,
        selectEvent = props.selectEvent,
        top = props.top,
        label = props.label,
        placeholder = props.placeholder,
        className = props.className,
        error = props.error,
        hideError = props.hideError,
        disabled = props.disabled,
        allowInternational = props.allowInternational,
        isCheckDOMValue = props.isCheckDOMValue;


    var autocompleteRef = (0, _react.useRef)(null);

    var _useState = (0, _react.useState)({
        id: Math.random().toString(36).slice(2, 11),
        description: null,
        loaded: false,
        mode: 'autocomplete',
        error: ''
    }),
        _useState2 = _slicedToArray(_useState, 2),
        state = _useState2[0],
        setState = _useState2[1];

    (0, _react.useEffect)(function () {
        if (!state.loaded) {
            if (address && !address.streetNumber && allowManual && state.mode !== 'manual') {
                setState(_extends({}, state, { mode: 'manual' }));
                changeEvent('code', 'MANUAL');
                changeEvent('location.latitude', '');
                changeEvent('location.longitude', '');
            } else if (state.mode === 'autocomplete' && window.google) {
                handleScriptLoad();
            }
        }
    }, []);

    (0, _react.useEffect)(function () {
        if (state.mode === 'autocomplete' && window.google) {
            handleScriptLoad();
        }
    }, [state.mode]);

    var handleQueryChanged = function handleQueryChanged(value) {
        setState(_extends({}, state, {
            description: value
        }));
        handleChange('address', {
            code: null,
            formattedAddress: value,
            apartmentSuite: address && address.apartmentSuite,
            location: {}
        });
    };

    var handleScriptLoad = function handleScriptLoad() {
        var options = {
            types: ['address'],
            componentRestrictions: { country: countryCode ? String(countryCode).toLowerCase() : 'can' }
        };
        /*global google*/
        autocompleteRef.current = new google.maps.places.Autocomplete(document.getElementById('AddressAutoComplete-' + state.id + '-Input'), options);
        autocompleteRef.current.addListener('place_changed', handlePlaceSelect);
        setState(_extends({}, state, { loaded: true }));
        if (address && address.formattedAddress) {
            setState(_extends({}, state, {
                description: address.formattedAddress
            }));
        }
    };

    var getAddressComponent = function getAddressComponent(address, type) {
        var long = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        var value = null;
        if (address && address.address_components && address.address_components.length > 0) {
            var component = address.address_components.find(function (x) {
                return x.types.some(function (y) {
                    return y === type;
                });
            });
            if (component) {
                value = long ? component.long_name : component.short_name;
            }
        }
        return value;
    };

    var handlePlaceSelect = function handlePlaceSelect() {
        var addressObject = autocompleteRef.current.getPlace();
        var newAddress = null;
        if (addressObject) {
            newAddress = {};
            newAddress.code = 'GMAPS.' + addressObject.place_id;
            newAddress.streetNumber = getAddressComponent(addressObject, 'street_number', true);
            newAddress.street = getAddressComponent(addressObject, 'route', true);
            newAddress.city = getAddressComponent(addressObject, 'locality', true);
            if (newAddress.city === null || newAddress.city === undefined) {
                newAddress.city = getAddressComponent(addressObject, 'sublocality_level_1', true);
            }
            newAddress.state = getAddressComponent(addressObject, 'administrative_area_level_1', true);
            newAddress.stateCode = getAddressComponent(addressObject, 'administrative_area_level_1');
            newAddress.country = getAddressComponent(addressObject, 'country', true);
            newAddress.countryCode = getAddressComponent(addressObject, 'country');

            // Every time new country is added, add here too! (Need to find better way for this)
            if (newAddress.countryCode === 'CA') {
                newAddress.countryCode = 'CAN';
            }
            if (newAddress.countryCode === 'US') {
                newAddress.countryCode = 'USA';
            }

            newAddress.postalCode = getAddressComponent(addressObject, 'postal_code', true);
            newAddress.formattedAddress = addressObject.formatted_address;
            newAddress.location = {
                latitude: '' + addressObject.geometry.location.lat(),
                longitude: '' + addressObject.geometry.location.lng()
            };

            if (address && address.apartmentSuite) {
                newAddress.apartmentSuite = address.apartmentSuite;
            }

            if (getAddressComponent(addressObject, 'subpremise', true)) {
                newAddress.apartmentSuite = getAddressComponent(addressObject, 'subpremise', true);
            }

            if (validateAddress(newAddress)) {
                setState(function (prevState) {
                    return _extends({}, prevState, {
                        error: ''
                    });
                });
            }

            setState(function (prevState) {
                return _extends({}, prevState, {
                    description: newAddress.formattedAddress
                });
            });

            handleChange('address', newAddress);
            selectEvent && selectEvent(newAddress);
        }
    };

    var validateAddress = function validateAddress(address) {
        var valid = false;
        if (address.streetNumber && address.streetNumber.length > 0 && address.street && address.street.length > 0 && address.city && address.city.length > 0 && address.state && address.state.length > 0 && address.country && address.country.length > 0 && address.countryCode && address.countryCode.length > 0 && address.postalCode && address.postalCode.length > 0) {
            if ((0, _validatePostalCode2.default)(address.postalCode, address.countryCode)) {
                valid = true;
                setState(_extends({}, state, { error: '' }));
            } else {
                setState(_extends({}, state, { error: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AddressAutocomplete.error.invalidPostalCode' }) }));
            }
        } else {
            setState(_extends({}, state, { error: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AddressAutocomplete.error.missingElement' }) }));
        }

        return valid;
    };

    var geoCode = function geoCode() {
        if (validateAddress(address)) {
            /*global google*/
            var geoCoder = new google.maps.Geocoder();
            var formattedAddress = getFormattedAddress(address);
            var geoCodeResult = new Promise(function (resolve, reject) {
                geoCoder.geocode({ 'address': formattedAddress }, function (results, status) {
                    if (status === 'OK') {
                        resolve([results[0].geometry.location.lat(), results[0].geometry.location.lng()]);
                    } else {
                        reject(new Error('Couldn\'t find the location ' + address));
                    }
                });
            });
            geoCodeResult.then(function (value) {
                changeEvent('formattedAddress', formattedAddress);
                changeEvent('location.latitude', '' + value[0]);
                changeEvent('location.longitude', '' + value[1]);
            });
        }
    };

    var getFormattedAddress = function getFormattedAddress(address) {
        var formattedAddress = '';
        if (address) {
            if (address.apartmentSuite && address.apartmentSuite.length > 0) {
                formattedAddress = address.apartmentSuite + '-';
            }
            if (address.streetNumber && address.streetNumber.length > 0) {
                formattedAddress = '' + formattedAddress + address.streetNumber + ' ';
            }
            if (address.street && address.street.length > 0) {
                formattedAddress = '' + formattedAddress + address.street;
            }
            if (address.city && address.city.length > 0) {
                formattedAddress = formattedAddress + ', ' + address.city;
            }
            if (address.stateCode && address.stateCode.length > 0) {
                formattedAddress = formattedAddress + ', ' + address.stateCode;
            } else if (address.state && address.state.length > 0) {
                formattedAddress = formattedAddress + ', ' + address.state;
            }
            if (address.postalCode && address.postalCode.length > 0) {
                formattedAddress = formattedAddress + ' ' + address.postalCode;
            }
            if (address.country && address.country.length > 0) {
                formattedAddress = formattedAddress + ', ' + address.country;
            }
        }
        return formattedAddress;
    };

    var handleChange = function handleChange(code, value) {
        var newAddress = code === 'address' ? _extends({}, value) : _extends({}, address, _defineProperty({}, code, value));
        changeEvent('address', newAddress, state.error);
    };

    var clearAddress = function clearAddress() {
        var code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var country = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var countryCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

        changeEvent('code', '');
        changeEvent('apartmentSuite', '');
        changeEvent('streetNumber', '');
        changeEvent('street', '');
        changeEvent('city', '');
        changeEvent('state', '');
        changeEvent('stateCode', '');
        changeEvent('formattedAddress', '');
        changeEvent('postalCode', '');
        changeEvent('country', country);
        changeEvent('countryCode', countryCode);
        changeEvent('location.latitude', '');
        changeEvent('location.longitude', '');
    };

    var handleClearAddress = function handleClearAddress() {
        clearAddress(address.code);

        setState(_extends({}, state, {
            description: ''
        }));
        selectEvent && selectEvent({
            code: address.code,
            apartmentSuite: '',
            streetNumber: '',
            street: '',
            city: '',
            state: '',
            stateCode: '',
            formattedAddress: '',
            postalCode: '',
            country: '',
            location: {
                lat: '',
                lng: ''
            }
        });
    };

    return _react2.default.createElement(
        _grid2.default,
        null,
        state.mode === 'autocomplete' && _react2.default.createElement(
            _row2.default,
            { nogutter: true },
            _react2.default.createElement(
                _column2.default,
                { xs: 12,
                    nogutterleft: true,
                    nogutterright: (0, _isMobile2.default)((0, _getScreenSize2.default)())
                },
                _react2.default.createElement(_input2.default, { id: 'AddressAutoComplete-' + state.id + '-',
                    key: 'AddressAutoComplete-' + state.id + '-',
                    hideClearBtn: true,
                    isCheckDOMValue: typeof isCheckDOMValue === 'boolean' ? isCheckDOMValue : true,
                    top: top,
                    label: label,
                    placeholder: placeholder,
                    value: state.description,
                    changeEvent: handleQueryChanged,
                    onClear: handleClearAddress,
                    className: className,
                    error: error || !!state.error,
                    errorLabel: !hideError && state.error,
                    disabled: disabled
                })
            ),
            allowManual && _react2.default.createElement(
                _column2.default,
                { xs: 12,
                    nogutter: true
                },
                _react2.default.createElement(
                    _container2.default,
                    { inline: true },
                    _react2.default.createElement(_label2.default, { inline: true,
                        top: _sizes.Sizes.xs,
                        textAlign: _alignments.Alignments.left,
                        text: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'AddressAutocomplete.tryAgain',
                            values: {
                                link: _react2.default.createElement(_link2.default, {
                                    secondaryStyle: true,
                                    top: _sizes.Sizes.xs,
                                    inline: true,
                                    clickEvent: function clickEvent() {
                                        changeEvent('code', 'MANUAL');
                                        changeEvent('location.latitude', '');
                                        changeEvent('location.longitude', '');
                                        setState(_extends({}, state, {
                                            mode: 'manual',
                                            error: '',
                                            loaded: false
                                        }));
                                    },
                                    text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AddressAutocomplete.manualEntryLink' })
                                })
                            }
                        })
                    })
                )
            )
        ),
        state.mode === 'manual' && _react2.default.createElement(
            _row2.default,
            { nogutter: true },
            _react2.default.createElement(
                _column2.default,
                { nogutter: true },
                _react2.default.createElement(_label2.default, {
                    inline: true,
                    top: _sizes.Sizes.xs,
                    textAlign: _alignments.Alignments.left,
                    text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AddressAutocomplete.enterAddress' })
                })
            ),
            _react2.default.createElement(
                _column2.default,
                { nogutter: true },
                _react2.default.createElement(_manualAddress2.default, _extends({}, props, {
                    changeEvent: handleChange,
                    allowInternational: allowInternational,
                    getFormattedAddress: getFormattedAddress,
                    geoCode: geoCode
                }))
            ),
            _react2.default.createElement(
                _column2.default,
                { nogutter: true },
                _react2.default.createElement(_label2.default, {
                    top: _sizes.Sizes.xs,
                    textAlign: _alignments.Alignments.left,
                    text: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'AddressAutocomplete.reset',
                        values: {
                            resetLink: _react2.default.createElement(_link2.default, {
                                secondaryStyle: true,
                                inline: true,
                                clickEvent: function clickEvent() {
                                    clearAddress('', address.country, address.countryCode);
                                    setState(_extends({}, state, {
                                        error: '',
                                        mode: 'autocomplete',
                                        description: ''
                                    }));
                                },
                                textAlign: _alignments.Alignments.left,
                                text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AddressAutocomplete.resetLink' })
                            })
                        }
                    })
                })
            )
        )
    );
};

AddressAutocomplete.propTypes = {
    address: _propTypes2.default.object,
    allowManual: _propTypes2.default.bool,
    countryCode: _propTypes2.default.string,
    changeEvent: _propTypes2.default.func,
    selectEvent: _propTypes2.default.func,
    top: _propTypes2.default.string,
    label: _propTypes2.default.string,
    placeholder: _propTypes2.default.string,
    className: _propTypes2.default.string,
    error: _propTypes2.default.bool,
    hideError: _propTypes2.default.bool,
    disabled: _propTypes2.default.bool,
    allowInternational: _propTypes2.default.bool,
    isCheckDOMValue: _propTypes2.default.bool
};

var WrappedAddressAutocomplete = (0, _script2.default)(AddressAutocomplete, 'gMaps', 'https://maps.googleapis.com/maps/api/js?libraries=places&key=@&gMaps&@');

exports.default = WrappedAddressAutocomplete;